
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/afterpay",
      function () {
        return require("private-next-pages/afterpay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/afterpay"])
      });
    }
  